// extracted by mini-css-extract-plugin
export default {"Item":"navItem__Item__ilxz2","Link":"navItem__Link__enk7T","ActiveLink":"navItem__ActiveLink__wdjxX navItem__Item__ilxz2","Ntf":"navItem__Ntf__vYxu2"};